import * as navigation from 'Navigation';

export default class MoleculePhysicochemicalPropertiesTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Physicochemical Properties',
      closeable: false,
      preferenceKey: 'molecule-physicochemical-properties',
    };
  }
}
